import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { getValidationPaiementClient, createValidationPaiementClient } from "../../services/finances/validation-paiement-client";
import Alert from "../../components/Alert";
import Pagination from "../../components/Pagination"
import { pathUrl } from "../..";

const ValidationPaiementClient = () => {
  
  const [validPaie, setValidPaie] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [flash, setFlash] = useState({ message: null, color: "" });
  const [loading, setLoading] = useState(false)

  const titleTable = "Validation des paiements par les clients";
  const headTable = [
    {name:"Date", width: ""},
    {name:"Nom du client", width: ""},
    {name:"Agence", width: ""},
    {name:"N° dossier", width: ""},
    {name:"N° de lot", width: ""},
    {name:"N° de reçu", width: ""},
    {name:"Référence", width: ""},
    {name:"Montant", width: ""},
    {name:"Date vers.", width: ""},
    {name:"Document", width: ""},
    {name:"", width: ""},

  ];
  const [currentTableData, setCurrentTableData] = useState([]);
  const [totalPage, setTotalPage] = useState(null);
  const PageSize = 10;
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };
  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), validPaie);
    setCurrentTableData(d);
    // console.log(d);
  };

  const mode = ["Espèce", "Chèque", "Reçu", "Virement", "Paiement mobile"];
  const footer = [
    {value: "Valider", type: "submit", className: "success"}
  ];

  const showDoc = (path) => {
    const source = pathUrl + path;
    window.open(source, '_blank');
  }

  const onChangeChechAll = (e) => {
    const checked = e.target.checked;
    const nameAll = document.querySelectorAll(".check");
    if(checked) {
      nameAll.forEach((name) => {
        name.checked = true;
      });
    } else {
      nameAll.forEach((name) => {
        name.checked = false;
      });
    }
  };
  
  const listValidationPaiementClient = () => {
    setIsLoading(true);
    getValidationPaiementClient()
      .then((res) => {
        const { data } = res;
        setIsLoading(false)
        setValidPaie(data);
        const d = page(1, data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.length / PageSize);
        setTotalPage(coutPage);
      })
      .catch();
  };

  const valideDossier = async () => {
    await valideDossierRecharge();
    const nameAll = document.querySelectorAll(".check");
    nameAll.forEach((name) => {
      name.checked = false;
    });
    // const check_all = document.getElementById("check-all");
    // check_all.checked = false;
    // console.log((check_all));
    setIsLoadingPage(() => !isLoadingPage);
    //window.location.reload(true);
  }

  const valideDossierRecharge = async () => {
    setIsLoading(true);
    const check_all = document.querySelectorAll('.check');
    const data = [];
    let i = 0;
    check_all.forEach((check) => {
      i++;
      if(check.checked) {
        data.push(
          {
            id: validPaie[i - 1].ID,
            iddossier: validPaie[i - 1].IDDOSSIER,  
            montant: validPaie[i-1].MONTANT,
            mode: validPaie[i-1].MODE,
            cheque: validPaie[i-1].NCHEQUE,
            observ: validPaie[i-1].OBSERV,  
            banque: validPaie[i-1].BANQUE,
            emetteur: validPaie[i-1].EMETT,  
            dateemiss: validPaie[i-1].DATEEMIS,  
            piece: validPaie[i-1].LIENDOCUMENT,  
          }
        );
      }
    })
    console.log(data)
    createValidationPaiementClient({ datas: data })
      .then(( data ) => {
        setIsLoading(false);
        const isOk = data.success;
        const message =  data.message;
        const color = isOk === undefined || isOk === "false" || isOk === false ?
          "danger" : "success";
        setFlash({ message: message, color: color });
        if(data.success){
          setValidPaie([])
          getValidationPaiementClient()
          .then((res) => {
            const { data } = res;
            setIsLoading(false)
            setValidPaie(data);
            const d = page(1, data);
            setCurrentTableData(d);
            const coutPage = parseInt(data.length / PageSize);
            setTotalPage(coutPage);
          })
          .catch();
        }
      })
      .catch((err) => {
        console.log(err);
        setFlash({ message: "Impossible de valider les paiements", color: "danger" });
    })
    setIsLoading(false)
  };

  const filterDossier = (e) => {
    const SEARCH = document.getElementById('search');
    getValidationPaiementClient({ search: SEARCH.value })
      .then(({ data }) => {
        setValidPaie(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    listValidationPaiementClient();
    //console.log(validPaie);
  }, [isLoadingPage]);

  //console.log(validPaie);

  return (
    <Layout>

<div className="row">
      <div className={`col-xs-1`}></div>
      <div className={`form-horizontal col-xs-10 ui-sortable`}>
        <div className="widget-box widget-color-blue">
          {/* Entete du cadre */}
          <div className="widget-header ui-sortable-handle">
              <h5 className="widget-title">{titleTable}</h5>
              <div className="navbar-form navbar-right form-search">
                  <div
                    id="ContentPlaceHolder1_Panel1"
                    onkeypress="javascript:return WebForm_FireDefaultButton(event, 'ContentPlaceHolder1_BTRECH')"
                  >
                    <span className="input-icon">
                      <input
                        name="search"
                        type="text"
                        id="search"
                        tabIndex={1}
                        className="nav-search-input"
                        placeholder="Recherche ..."
                      />
                      <i className="ace-icon fa fa-search nav-search-icon" />
                      <button type="button" className="btn-info btn-sm" onClick={filterDossier}>Rechercher</button>
                    </span>
                  </div>
              </div>
          </div>
          {flash.message !== null && <Alert color={flash.color} message={flash.message} />}
          {/* Contenu du cadre */}
          <div className="widget-body">
            <div className="widget-main">
              <span
                id="ContentPlaceHolder1_LBINFO"
                style={{
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center"
                }}
              />
              <label className="block clearfix">
                <span className="block">
                <table
                    cellSpacing={0}
                    rules="all"
                    className="table-header table table-striped "
                    border={1}
                    id="ContentPlaceHolder1_GV"
                    style={{
                      borderColor: "#E1E1E1",
                      fontSize: "10pt",
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <tbody>
                      <tr
                        align="center"
                        valign="middle"
                        style={{
                          color: "#707070",
                          backgroundColor: "#F1F1F1",
                          fontWeight: "normal",
                        }}
                      >
                        {headTable?.map((item, index) => {
                          return (
                            <th
                              key={index}
                              className="text-center"
                              scope="col"
                              style={{ width: item?.width }}
                            >
                              {item?.name}
                            </th>
                          );
                        })}
                      </tr>

                      {validPaie?.map((item, key) => (
                      <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
                        <td>{item?.DATE}</td>
                        <td>{item?.NOM}</td>
                        <td>{item?.LIBELLE}</td>
                        <td>{item?.NUMDOSSIER}</td>
                        <td>{item?.NUMLOT}</td>
                        <td>{item?.NRECU}</td>
                        <td>{item?.NCHEQUE}</td>
                        <td>{item?.MONTANT}</td>
                        <td>{item?.DATEEMIS}</td>
                        <td>
                          <a href="#"  onClick={(e) => {
                          e.preventDefault();
                          showDoc(item.LIENDOCUMENT);
                          return false;
                          }}>
                            {item?.APPERCU}
                          </a>
                          </td>
                        <td>
                          <input type="checkbox" className="check" id={`check-${key}`} />
                        </td>
                      </tr>
                  ))}
                      <div className="row ml-4">
                        <div className="px-3"></div>
                        <input type="checkbox" name="check-all" id="check-all" onChange={onChangeChechAll} />
                      <label htmlFor="check-all">Cocher tout</label>
                      </div>
                    </tbody>
                    <Pagination onPageChange={onPageChange} totalPage={totalPage} />
                  </table>
                </span>
              </label>
            </div>
            {/* Pied du cadre */}
            {footer?.map((btn, key) => (
              <div className="widget-toolbox padding-8 clearfix" key={key}>
              <div className="pull-right">
                <input
                  type={btn.type}
                  name={btn.name}
                  value={btn.value}
                  id={btn.id}
                  disabled={isLoading}
                  className={`btn btn-${btn.className}`}
                  style={{ borderStyle: "None", width: 100 }}
                  onClick={() => valideDossier()}
                />
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </Layout>
  );
};

export default ValidationPaiementClient;
